import { addEventListeners, removeEventListeners } from "../utils/dom";
import { Collapse } from "bootstrap";

export default class PaymentTypeCollapse extends HTMLFieldSetElement {

    connectedCallback() {

        addEventListeners(this.radioElements, "change", this.handleChange);

    }

    disconnectedCallback() {

        removeEventListeners(this.radioElements, "change", this.handleChange);

    }

    handleChange = (e) => {
        const selectedOption = e.target;

        const collapse = Collapse.getOrCreateInstance(this.collapseTarget, { toggle: false });

        if (selectedOption.value === "140960012") {
            collapse.show();
        }
        else {
            collapse.hide();
        }

    }

    get collapseTarget() {
        return document.querySelector(this.dataset.target);
    }

    get radioElements() {
        return this.querySelectorAll("input[type=radio]");
    }

}

customElements.define('payment-type-collapse', PaymentTypeCollapse, { extends: 'fieldset' });